import useBeautyFilterStore from 'stores/beautyFilter/beautyFilterStore';
import useBeautyFilterBanubaStore from 'stores/beautyFilter/beautyFilterBanubaStore';

const useMakeup = () => {
  const store = useBeautyFilterStore();
  const { selectedItem: selectedMenuItem } = store.menu;
  const { keys, table, selectedKey, selectedSubKey, setSelectedKey, setSelectedSubKey, resetSelectedKey, resetSelectedSubKey } = store.makeup;
  const { isMakeupKeyUsing, resetMakeupState } = useBeautyFilterBanubaStore();

  const handleItemSelect = (key: string) => {
    setSelectedKey(key);
    // 단일 색상 하이라이터 예외
    if (key === 'makeup_highlighter') {
      setSelectedSubKey('Champagne');
    } else {
      resetSelectedSubKey();
    }
  };

  const handleItemAllReset = () => {
    resetMakeupState();
    resetSelectedKey();
    resetSelectedSubKey();
  };

  const handleSubItemAllReset = (key: string) => {
    resetMakeupState(key);
    resetSelectedSubKey();
  };

  const isTabVisible = selectedMenuItem.id === 'makeup' && (selectedKey === null || selectedKey === 'makeup_highlighter'); // 단일 색상 하이라이터 예외

  const isSubTabVisible = (key: string) => selectedMenuItem.id === 'makeup' && selectedKey === key && selectedKey !== 'makeup_highlighter'; // 단일 색상 하이라이터 예외

  const isItemSelected = (key: string) => selectedKey === key;

  const isSubItemSelected = (subKey: string) => selectedSubKey === subKey;

  const isItemUsing = (key: string) => isMakeupKeyUsing(key);

  return {
    keys,
    table,
    isTabVisible,
    isSubTabVisible,
    isItemSelected,
    isSubItemSelected,
    isItemUsing,
    handleItemSelect,
    handleSubItemSelect: setSelectedSubKey,
    handleItemAllReset,
    handleSubItemAllReset,
  };
};

export default useMakeup;
